import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './stile.css';
import { router } from './routes';
import { FornitoreSessione } from '@errebi/sessione';

const coda = new QueryClient({
  defaultOptions: { queries: { staleTime: 0, retry: 1 } },
});

const contenitore = document.getElementById('radice');
if (!contenitore) throw new Error('manca #radice in index.html');

createRoot(contenitore).render(
  <StrictMode>
    <QueryClientProvider client={coda}>
      <FornitoreSessione>
        <RouterProvider router={router} />
      </FornitoreSessione>
    </QueryClientProvider>
  </StrictMode>,
);
